import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/opt/build/repo/layouts/login.vue").then(m => m.default || m))
}